import { render, staticRenderFns } from "./ProcessManagementChecklist.vue?vue&type=template&id=196d5ac6"
import script from "./ProcessManagementChecklist.vue?vue&type=script&lang=js"
export * from "./ProcessManagementChecklist.vue?vue&type=script&lang=js"
import style0 from "./ProcessManagementChecklist.vue?vue&type=style&index=0&id=196d5ac6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports